import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";


// Wrapper qui affiche le fallback au moins 1s, puis charge dynamiquement le composant mission
export function MissionLoader({
  importer,
  fallback,
  minDuration = 1000,
}: {
  importer: () => Promise<{ default: React.ComponentType<any> }>,
  fallback: React.ReactNode,
  minDuration?: number,
}) {
  const [LoadedComponent, setLoadedComponent] = useState<React.ComponentType<any> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    let timeout: NodeJS.Timeout | null = null;
    setLoadedComponent(null);
    setLoading(true);

    importer().then((mod) => {
      timeout = setTimeout(() => {
        if (isMounted) {
          setLoadedComponent(() => mod.default);
          setLoading(false);
        }
      }, minDuration);
    });

    return () => {
      isMounted = false;
      if (timeout) clearTimeout(timeout);
    };
  }, [importer, minDuration]);

  if (loading || !LoadedComponent) {
    return <>{fallback}</>;
  }

  // Fade-in au montage du composant mission
  return (
    <motion.div
      key="mission-content"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="h-full border-none"
    >
      <LoadedComponent />
    </motion.div>
  );
}

